// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__st6AZ","ThumbZoom":"ChapterPlayer_ThumbZoom__26MpA"};